import { Stack } from '@mui/material';
import { z } from 'zod';

import { api } from 'common';

import { type AsynchronousJobVariant, OptionalStringSchema, RequiredStringSchema } from './common';
import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';

import JobKind = api.RpaJob.Kind;

export const ExportPatientInsuranceInformation: AsynchronousJobVariant = {
  schema: z.object({
    jobKind: z.literal(JobKind.ExportPatientInsuranceInformation),
    payload: z.object({
      previsitFormSetId: RequiredStringSchema,
      encounterEhrReferenceValue: OptionalStringSchema,
      encounterStartTime: OptionalStringSchema,
    }),
  }),
  Config: () => {
    return (
      <Stack spacing={2}>
        <BlockValueTemplateField
          fieldName="config.payload.previsitFormSetId"
          label="Form Set Id"
          helperText="Enter the reference to the form set that contains the patient insurance information you wish to export e.g. `{{form.data.formSet.id}}`"
          placeholder="e.g. {{form.data.formSet.id}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.encounterEhrReferenceValue"
          label="Encounter Ehr Reference Value"
          helperText="Enter the reference encounter reference value you wish to export the form to e.g. `{{encounter.data.ehrReferenceValue}}`"
          placeholder="e.g. {{encounter.data.ehrReferenceValue}}"
        />
        <BlockValueTemplateField
          fieldName="config.payload.encounterStartTime"
          label="Encounter Start Time"
          helperText="Enter the start date time encounter reference value you wish to export the form to e.g. `{{encounter.data.encounterStartTime}}` This should be formatted in ISO format."
          placeholder="e.g. {{encounter.data.encounterStartTime}}"
        />
      </Stack>
    );
  },
};
